const translations = {
  fr: {
    streaming: {
      streamingPageTitle: 'Streams',
      streamDataPageTitle: 'Métriques de Streaming',
      nbOfConnections: 'Nombre de Connexions',
      streamStatus: 'Status',
      errorWhileFetchingLiveMetricsMessage: "Il y a eu problème lorsque nous avons essayer d'obtenir les données en temps réel",
      bitrate: 'Débit',
      bitrateUnits: '{{ value }} kbps',
      connections: 'Connexions',
      uniqueConnections: 'Connexions uniques',
      peakConnections: 'Maximum de connexions',
      listeningTimeMinutes: 'Total minutes',
      listeningTimeHours: 'Total heures',
      sessions: 'Sessions',
      totalSessions: 'Sessions totales',
      dailyAverageSessions: 'Moyenne de session par jour',
      hourlyAverageSessions: 'Moyenne de session par heure',
      averageSessionDuration: 'Durée moyenne par session',
      streamUrl: 'Lien du stream',
      serverType: 'Type de serveur',
      mediaType: 'Format',
    },
  },
  en: {
    streaming: {
      streamingPageTitle: 'Streams',
      streamDataPageTitle: 'Stream Metrics',
      nbOfConnections: 'Total Live Connections',
      streamStatus: 'Status',
      errorWhileFetchingLiveMetricsMessage: 'Error while fetching live metrics',
      bitrate: 'Bitrate',
      bitrateUnits: '{{ value }} kbps',
      connections: 'Connections',
      uniqueConnections: 'Unique Connections',
      peakConnections: 'Peak Connections',
      listeningTimeMinutes: 'Total Minutes',
      listeningTimeHours: 'Total Hours',
      sessions: 'Sessions',
      totalSessions: 'Total Sessions',
      dailyAverageSessions: 'Average Sessions Per Day',
      hourlyAverageSessions: 'Average Sessions Per Hour',
      averageSessionDuration: 'Average Session Length',
      streamUrl: 'Stream url',
      serverType: 'Server type',
      mediaType: 'Media type',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/streaming/i18n/streaming.js